import { render, staticRenderFns } from "./paymentReviewTemplate.vue?vue&type=template&id=fd211a8c"
import script from "./paymentReviewTemplate.vue?vue&type=script&lang=js"
export * from "./paymentReviewTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports